module.exports = "div{\n    text-align: center;\n    font-size: 1.6rem;\n}\n.container{\n    padding: 1rem;\n}\n.no-padding{\n    padding: 0;\n}"


//////////////////
// WEBPACK FOOTER
// ./src/app/app-footer/app-footer.component.css
// module id = ./src/app/app-footer/app-footer.component.css
// module chunks = main